import React from 'react';

interface Props {
  width?: string;
  height?: string;
}

const ComingSoonSVG: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      width={width ?? '67'}
      height={height ?? '9'}
      viewBox='0 0 67 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 4.48828C0 2.09049 1.43759 0.488281 3.62141 0.488281C4.23596 0.488281 4.87245 0.620878 5.26751 0.830822V2.44408C4.87245 2.20099 4.36764 2.03524 3.86284 2.03524C2.63376 2.03524 1.8546 3.04077 1.8546 4.48828C1.8546 5.93579 2.63376 6.94132 3.86284 6.94132C4.36764 6.94132 4.87245 6.77557 5.26751 6.53248V8.14574C4.87245 8.35568 4.23596 8.48828 3.62141 8.48828C1.43759 8.48828 0 6.88607 0 4.48828Z'
        fill='#E7CDFF'
      />
      <path
        d='M9.17365 0.488281C11.2697 0.488281 12.5866 2.12364 12.5866 4.48828C12.5866 6.84187 11.2697 8.48828 9.17365 8.48828C7.06664 8.48828 5.74977 6.84187 5.74977 4.48828C5.74977 2.12364 7.06664 0.488281 9.17365 0.488281ZM9.17365 2.03524C8.13112 2.03524 7.60437 3.02972 7.60437 4.48828C7.60437 5.94684 8.13112 6.94132 9.17365 6.94132C10.2052 6.94132 10.732 5.94684 10.732 4.48828C10.732 3.02972 10.2052 2.03524 9.17365 2.03524Z'
        fill='#E7CDFF'
      />
      <path
        d='M19.0427 0.620878H20.8205V8.35568H19.0537V3.63745L17.6051 7.02972H16.5735L15.125 3.63745V8.35568H13.3582V0.620878H15.1469L17.0674 4.74242H17.1113L19.0427 0.620878Z'
        fill='#E7CDFF'
      />
      <path
        d='M23.5539 0.620878V8.35568H21.7871V0.620878H23.5539Z'
        fill='#E7CDFF'
      />
      <path
        d='M24.5255 0.620878H26.1716L28.7834 5.08497H28.8163V0.620878H30.5831V8.35568H28.937L26.3362 3.8916H26.2923V8.35568H24.5255V0.620878Z'
        fill='#E7CDFF'
      />
      <path
        d='M35.2156 0.488281C36.0386 0.488281 36.708 0.620878 37.136 0.830822V2.44408C36.6861 2.20099 36.0606 2.03524 35.479 2.03524C34.0743 2.03524 33.2183 2.99657 33.2183 4.56563C33.2183 6.13469 33.9755 6.94132 34.8864 6.94132C35.1827 6.94132 35.468 6.83082 35.6765 6.63193V5.40541H34.4584V3.85845H37.4433V7.81425C36.7519 8.25624 35.9508 8.48828 35.1278 8.48828C33.1196 8.48828 31.3637 7.18441 31.3637 4.48828C31.3637 2.09049 32.9001 0.488281 35.2156 0.488281Z'
        fill='#E7CDFF'
      />
      <path
        d='M40.6757 2.85292C40.6757 1.11812 42.0475 0.488281 43.4083 0.488281C44.0228 0.488281 44.6593 0.620878 45.0653 0.830822V2.44408C44.6593 2.20099 44.1325 2.03524 43.6497 2.03524C42.9474 2.03524 42.5303 2.34463 42.5303 2.85292C42.5303 4.13469 45.5372 3.44961 45.5372 6.09049C45.5372 7.8474 44.1545 8.48828 42.6181 8.48828C41.9377 8.48828 41.2135 8.35568 40.6428 8.14574V6.53248C41.2574 6.77557 41.8719 6.94132 42.4535 6.94132C43.2546 6.94132 43.6826 6.60983 43.6826 6.09049C43.6826 4.78662 40.6757 5.46066 40.6757 2.85292Z'
        fill='#E7CDFF'
      />
      <path
        d='M49.347 0.488281C51.443 0.488281 52.7599 2.12364 52.7599 4.48828C52.7599 6.84187 51.443 8.48828 49.347 8.48828C47.24 8.48828 45.9231 6.84187 45.9231 4.48828C45.9231 2.12364 47.24 0.488281 49.347 0.488281ZM49.347 2.03524C48.3045 2.03524 47.7777 3.02972 47.7777 4.48828C47.7777 5.94684 48.3045 6.94132 49.347 6.94132C50.3785 6.94132 50.9053 5.94684 50.9053 4.48828C50.9053 3.02972 50.3785 2.03524 49.347 2.03524Z'
        fill='#E7CDFF'
      />
      <path
        d='M56.7578 0.488281C58.8539 0.488281 60.1708 2.12364 60.1708 4.48828C60.1708 6.84187 58.8539 8.48828 56.7578 8.48828C54.6508 8.48828 53.334 6.84187 53.334 4.48828C53.334 2.12364 54.6508 0.488281 56.7578 0.488281ZM56.7578 2.03524C55.7153 2.03524 55.1886 3.02972 55.1886 4.48828C55.1886 5.94684 55.7153 6.94132 56.7578 6.94132C57.7894 6.94132 58.3162 5.94684 58.3162 4.48828C58.3162 3.02972 57.7894 2.03524 56.7578 2.03524Z'
        fill='#E7CDFF'
      />
      <path
        d='M60.9424 0.620878H62.5885L65.2003 5.08497H65.2332V0.620878H67V8.35568H65.3539L62.7531 3.8916H62.7092V8.35568H60.9424V0.620878Z'
        fill='#E7CDFF'
      />
    </svg>
  );
};

export default ComingSoonSVG;
